import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';
const SvgComponent = (props: SvgProps) => (
  <Svg fill="none" viewBox="0 0 26 111" {...props}>
    <Path d="M10.5 3.001a2.5 2.5 0 0 1 5 0v87.5h-5v-87.5ZM25.5 90.501H.5l12.626 20 12.374-20Z" />
  </Svg>
);
const Memo = memo(SvgComponent);
export default Memo;
